import { render, staticRenderFns } from "./Celebrities.vue?vue&type=template&id=692b7f4c&scoped=true&"
import script from "./Celebrities.vue?vue&type=script&lang=js&"
export * from "./Celebrities.vue?vue&type=script&lang=js&"
import style0 from "./Celebrities.vue?vue&type=style&index=0&id=692b7f4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692b7f4c",
  null
  
)

export default component.exports